<template>
  <router-view />
</template>

<script>
export default {
  name: "BillingComponent",
};
</script>

<style scoped></style>
